import React from 'react';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import { loadActiveCases } from '../store/browserStorage.js';
import { VITE_MAX_ALLOWED_OPEN_CASE_LIMIT } from 'Constants/appEnvConstants';

export function gotoNewTabCaseLandingPage(caseNumber, queueId) {
  const activeCases = loadActiveCases();
  // eslint-disable-next-line no-undef
  if (activeCases.length < VITE_MAX_ALLOWED_OPEN_CASE_LIMIT) {
    if (queueId === 6 || queueId === 8) {
      window.open(`#/queue/${queueId}/caseselection/${caseNumber}`);
    } else {
      sessionStorage.setItem('queueid', queueId);
      window.open('#/caselanding/' + `${caseNumber}`);
    }
  } else {
    const notificationContent = (
      <div style={{ color: 'black' }}>
        <p>
          You have reached the maximum number of allowable open cases. To continue, you will need to close some cases.
        </p>
      </div>
    );
    const notificationMessageSuccess = {
      type: 'info',
      placement: 'topRight',
      messageWidth: 250,
      byDefault: true,
      duration: 10,
      content: notificationContent,
    };

    return openNotificationToast(notificationMessageSuccess);
  }
}

export default {
  gotoNewTabCaseLandingPage,
};
